import {SavedReportsLimitResults} from 'app_api/me/types';

import {BaseClient} from '../utils/base-client';

class SavedReportsLimitClient extends BaseClient<SavedReportsLimitResults> {
  buildEndpoint() {
    return `api/app/me/saved-reports-limit`;
  }

  buildQueryParams({projectId}) {
    return {
      project_id: projectId,
    };
  }

  processResponse(response) {
    return response.results;
  }
}

export const savedReportsLimitClient = new SavedReportsLimitClient({cacheTtl: 0}); // do not use client cache, fresh data when requested is critical
